import { Status_Enum as CampaignStatus } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';

export const LIMITED_EDIT_CAMPAIGN_STATUSES = [
  CampaignStatus.COMPLETED,
  CampaignStatus.PROCESSING,
  CampaignStatus.SCHEDULED,
];

export const NEW_CAMPAIGN_ID = 'new';
